/**
 * Praxara wordmark + glyph. Used in sidebar, auth screens, email templates.
 * The glyph is a stylised caduceus-free monogram — two stacked diagonals
 * that read as "P + ?" (Praxara + precision / change in regulatory state).
 */
import { cn } from '@/lib/utils';

interface Props {
  variant?: 'light' | 'dark' | 'icon';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function BrandMark({ variant = 'dark', size = 'md', className }: Props) {
  const h = size === 'sm' ? 20 : size === 'lg' ? 40 : 28;

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <BrandGlyph size={h} variant={variant} />
      {variant !== 'icon' && (
        <span
          className={cn(
            'font-display font-semibold tracking-tight',
            size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-2xl' : 'text-lg',
            variant === 'light' ? 'text-white' : 'text-foreground',
          )}
        >
          Praxara
        </span>
      )}
    </div>
  );
}

function BrandGlyph({ size, variant }: { size: number; variant: 'light' | 'dark' | 'icon' }) {
  const fillPrimary = variant === 'light' ? 'white' : 'hsl(var(--primary))';
  const fillAccent = variant === 'light' ? 'rgba(255,255,255,0.5)' : 'hsl(var(--accent))';
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect width="40" height="40" rx="10" fill={fillPrimary} opacity={variant === 'light' ? 0.12 : 1} />
      {/* P-like upstroke */}
      <path d="M12 11 L12 29 L16 29 L16 22 L22 22 Q28 22 28 17 Q28 11 22 11 Z" fill={variant === 'light' ? 'white' : 'white'} />
      {/* accent triangle (?) */}
      <path d="M28 29 L24 22 L32 22 Z" fill={fillAccent} />
    </svg>
  );
}
